module.exports = __webpack_public_path__ + "img/header_bg.54ec9370.png";